module.exports = __webpack_public_path__ + "media/images/xpass/markers/inactive-selected/purebarre-98c737f405be009808950f0de2dffff4.png";